import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Lottie from 'react-lottie';

import IconFullScreen from '../atoms/IconFullScreen';

import Wall1 from '../assets/images/wall-1.jpg';
import Wall2 from '../assets/images/wall-2.jpg';
import Wall3 from '../assets/images/wall-3.jpg';
import Wall4 from '../assets/images/wall-4.jpg';
import Wall5 from '../assets/images/wall-5.jpg';
import Wall6 from '../assets/images/wall-6.jpg';
import Wall7 from '../assets/images/wall-7.jpg';
import Wall8 from '../assets/images/wall-8.jpg';
import Wall9 from '../assets/images/wall-9.jpg';
import animationData from '../assets/animations/loader.json';

class WallNavImage extends Component {

  constructor( props ) {
    super( props );
    this.image = React.createRef();
    this.state = {
      img: undefined,
      loading: true
    };
  }


  setImg( wall ) {
    switch ( parseInt( wall ) ) {
      case 1:
        this.setState( { img: Wall1 } );
        break;
      case 2:
        this.setState( { img: Wall2 } );
        break;
      case 3:
        this.setState( { img: Wall3 } );
        break;
      case 4:
        this.setState( { img: Wall4 } );
        break;
      case 5:
        this.setState( { img: Wall5 } );
        break;
      case 6:
        this.setState( { img: Wall6 } );
        break;
      case 7:
        this.setState( { img: Wall7 } );
        break;
      case 8:
        this.setState( { img: Wall8 } );
        break;
      case 9:
        this.setState( { img: Wall9 } );
        break;
      default:
        this.setState( { img: false } );
    }
  }

  componentDidMount() {
    this.setImg( this.props.wall );
    window.addEventListener("resize", this.resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeHandler);
  }

  componentDidUpdate( prevProps ) {
    if ( this.props.wall !== prevProps.wall ) {
      this.setImg( this.props.wall );
    }
  }

  resizeHandler = () => {
    if( this.image.current ) {
      this.props.resizeHandler(this.image.current.offsetHeight);
    }
  };

  imageLoadHandler = () => {
    this.resizeHandler();
    this.setState( {
      loading: false,
    } )
  };

  render() {
    let classes = classNames("WallNavImage", {'isLoading': this.state.loading});
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    return (
      <div className={classes}>
        <img
          ref={this.image}
          alt="Wall"
          className="WallNavImage"
          src={this.state.img}
          onLoad={this.imageLoadHandler}/>
        <div className="WallNavImageLoader">
          <Lottie options={defaultOptions}
            height={60}
            width={60}/>
        </div>
        <Link className="FullScreenLink" to={`/wall-photo?wall=${this.props.wall}`}>
          <IconFullScreen /> Enlarge wall image
        </Link>
      </div>
    )
  }
}

export default WallNavImage;